/*eslint-disable */
import countries from '@/services/country.json';
export default {
  name: 'deactivated-users-list',
  components: {},
  props: [],
  data () {
    return {
      getDeactivatedUserListData:null,
      getDeactivatedUserListResults:[],
      countryList:[]
    }
  },
  computed: {

  },
  mounted () {
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key].toLowerCase(),
        value: key.toLowerCase()
      })
    });
    this.countryList.sort((a, b) => (a.name > b.name) ? 1 : -1)
    this.getDeactivatedUserListDataFunc()
  },
  methods: {
    getDeactivatedUserListDataFunc(){
      this.$store.dispatch('getDeactivatedAllUserListsFun').then((res) => {
        this.getDeactivatedUserListData = res.data 
        this.getDeactivatedUserListResults = this.getDeactivatedUserListData.data 
      })
    },
    getCountryFlag: function(countryCode, type) {
      if (countryCode == null) {
        countryCode = ''
      }
      let countryName = countryCode.toLowerCase()
      let country = this.countryList.filter(item => (item.value) == (countryName) || (item.name) == (countryName));
      if (country && country.length > 0) {
        country = country[0]
        if (type == 'flag') {
          country = `https://567c9b4f06e54c9c9229fe11191a6432.s3.ca-central-1.amazonaws.com/media/shiny/${country.value}.png`
        } else {
          country = country.name
        }
      } else {
        country = ''
      }
      return country;
    },
  }
}


